import { ValidateContact, ValidateDate, ValidateNumber, ValidateRadio, ValidateText } from "@/util/ValidationUtil";
import { Nullable } from "@/type/Common.ts";

export class InspectionOutlineDto {
    inspectionOutlineId?: bigint;
    /**
     * 충전소 ID
     */
    stationId: Nullable;
    /**
     * 점검 개요
     * */
    @ValidateRadio("점검 유형")
    businessName: Nullable;
    /**
     * 점검자 Id
     * */
    inspectorId: Nullable;
    /**
     * 점검자 소속
     */
    @ValidateText("점검자 소속")
    inspectorCompany: Nullable;
    /**
     * 점검자 성명
     */
    inspectorName: Nullable;
    /**
     * 점검자 연락처
     */
    @ValidateContact("점검자 연락처")
    inspectorCellphoneNumber: Nullable;
    /**
     * 점검일
     */
    @ValidateDate("점검일")
    inspectDate: Nullable;
    /**
     * 점검시 주변 온도
     */
    @ValidateNumber("온도")
    temperature: Nullable<number>;
    /**
     * 점검시 주변 습도
     */
    @ValidateNumber("습도")
    humidity: Nullable<number>;
    /**
     * Site 담당자 성명
     */
    @ValidateText("담당자명", false)
    siteManagerName: Nullable;
    /**
     * Site 담당자 연락처
     */
    @ValidateContact("담당자 연락처", false)
    siteManagerPhoneNumber: Nullable;
    /**
     * Site 등록 전기차 수
     */
    @ValidateNumber("등록 전기차 수", false)
    siteEvCount: Nullable<number>;
    /**
     * 관제, 현장 정보 구분
     */
    isNotCorrect: Nullable<boolean> = false;
    /**
     * 정보 불일치 시 내용
     */
    notCorrectDetail: Nullable;
    /**
     * 임시저장 여부
     */
    isCompleted: boolean;
}